// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2MRba","title":"ClientInsurance_title__2YNia","itemText":"ClientInsurance_itemText___bsQh"};